module.exports = __webpack_public_path__ + "fonts/AvertaStd-Thin.bb6967a2.ttf";